import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import {
  ManagementActionEnums,
  ManagementTypeEnums,
  ManagementTypeTypes,
  hasAnyManagementPermission,
  hasManagementPermission,
} from "@hooks/dtos/user-dto";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const routePermissionMap: Record<string, ManagementTypeTypes> = {
  "/management/trackings": ManagementTypeEnums.TRACKING,
  "/management/users": ManagementTypeEnums.CUSTOMER,
  "/management/users/list": ManagementTypeEnums.CUSTOMER,
  "/management/users/access-map": ManagementTypeEnums.CUSTOMER,
  "/management/webhooks": ManagementTypeEnums.WEBHOOK,
};

const ManagementRoute = () => {
  const { customer } = ZuAuthStore();
  const location = useLocation();
  const access = customer?.customer?.access;
  const requiredPermission = routePermissionMap[location.pathname];

  const hasManagementAccess = requiredPermission
    ? hasManagementPermission(
        access,
        requiredPermission,
        ManagementActionEnums.VIEW,
      )
    : hasAnyManagementPermission(access);

  return hasManagementAccess ? <Outlet /> : <Navigate to="/" replace />;
};

export default ManagementRoute;
